/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl, intlShape } from 'react-intl';
import { Panel, Button, Table } from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import TablePagerTDM from 'loracoms/TablePagerTDM';
import LoadingTable from 'loracoms/LoadingTable';
import Checkbox from 'loracoms/Checkbox';
import SearchInput from 'loracoms/SearchInput';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import { pageParams, updateMarks } from 'lorautils/pagerUtil';
import CreateModal from './CreateModal';
import DeleteModal from './DeleteModal';
import styles from '../styles.scss';

const kLimit = 10;
const kRouterAction = ['POP', 'REPLACE'];
const kMarksKey = 'pairsMarks';

const propTypes = {
  intl: intlShape.isRequired,
  network: PropTypes.string.isRequired,
  routerAction: PropTypes.string.isRequired,
  pushState: PropTypes.func.isRequired,
};

class Pairs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      status: '',
      checked: [],
      network: props.network,
    };
    this.marks = [];
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.pairs');
    this.callback = this.callback.bind(this);
    this.handlePaging = this.handlePaging.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
  }

  componentDidMount() {
    if (_.includes(kRouterAction, this.props.routerAction)) {
      this.marks = pageParams.getMarks(kMarksKey) || [];
      if (this.marks.length > 1) {
        this.mark = this.marks[this.marks.length - 2];
      }
    }
    this.loadData();
  }

  componentWillReceiveProps({ network }) {
    if (network !== this.props.network) {
      this.setState({ network });
    }
  }

  componentWillUnmount() {
    pageParams.setMarks(this.marks, kMarksKey);
  }

  onCheckedAll(c) {
    let { checked } = this.state;
    const { list } = this.state;
    if (c) {
      checked = [];
      list.forEach((l) => {
        checked = _.concat(checked, [l.id]);
      });
    } else {
      checked = [];
    }
    this.setState({ checked });
  }

  onCheckedSingle(c, id) {
    let { checked } = this.state;
    if (c) {
      checked = _.concat(checked, [id]);
    } else {
      checked = _.filter(checked, h => h !== id);
    }
    this.setState({ checked });
  }

  onChangeSearch(e) {
    this.q = e.target.value;
    this.setState({ search: this.q });

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    this.searchTimer = _.delay(() => {
      this.resetMark();
      this.loadData();
    }, 250);
  }

  loadData() {
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: '/tdmng/pairs',
      query: { mark: this.mark, limit: kLimit, q: this.q },
    }).then(({ list, more, mark }) => {
      this.marks = updateMarks(this.marks, mark);
      this.setState({ more, mark: this.marks, list, status: 'success' });
    }).catch(() => {});
  }

  checkedAll() {
    const { list, checked } = this.state;
    return (
      list.length > 0 &&
        list.length === checked.length
    );
  }

  handlePaging(mark) {
    this.mark = mark;
    this.setState({ checked: [] });
    this.loadData();
  }

  deletePair(pair) {
    callAPI({
      method: 'DELETE',
      endpoint: `/tdmng/pairs/${pair.id}`,
    }).then(() => {
      this.callback();
      this.setState({ deletePair: pair });
    }).catch(() => {});
  }

  callback() {
    this.resetMark();
    this.loadData();
  }

  resetMark() {
    this.mark = 0;
    this.marks = [];
    this.setState({ reset: new Date().valueOf() });
  }

  renderTable() {
    const { status, list, checked } = this.state;
    const thead = (
      <thead>
        <tr>
          <th>
            <Checkbox
              id="allPairs"
              checked={this.checkedAll()}
              onChange={c => this.onCheckedAll(c)}
            />
          </th>
          <th>{this.intlMsg.msg('name1')}</th>
          <th>{this.intlMsg.msg('id1')}</th>
          <th>{this.intlMsg.msg('name2')}</th>
          <th>{this.intlMsg.msg('id2')}</th>
          <th>{this.intlMsg.msg('remark')}</th>
          <th>{this.intlMsg.msg('remove')}</th>
        </tr>
      </thead>
    );
    if (status === 'success') {
      return (
        <Table className="aisz-table-light">
          {thead}
          <tbody>
            {_.map(list, (l) => {
              const memo = l.memo ? JSON.parse(l.memo) : {};
              return (
                <tr key={l.id}>
                  <td>
                    <Checkbox
                      id={`${l.id}-pairs`}
                      checked={_.includes(checked, l.id)}
                      onChange={c => this.onCheckedSingle(c, l.id)}
                    />
                  </td>
                  <td>{memo.name || '--'}</td>
                  <td>{normalizeDevEUI(l.id)}</td>
                  <td>{memo.rname || '--'}</td>
                  <td>{normalizeDevEUI(l.rnode)}</td>
                  <td>{memo.remark}</td>
                  <td>
                    <a
                      className={styles.deleteBtn}
                      onClick={() => this.deletePair(l)}
                    >
                      <i className="halflings halflings-trash" />
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      );
    }
    const rows = Math.max(1, list.length);
    return (
      <LoadingTable
        className="aisz-table-light"
        striped
        bordered
        rows={rows}
        cols={6}
      >
        {thead}
      </LoadingTable>
    );
  }

  render() {
    const {
      list,
      status,
      network,
      checked,
      search,
      mark = '',
      reset = 0,
      more = false,
      deletePair = {},
      showCreate = false,
      showDelete = false,
    } = this.state;

    const header = (
      <div>
        {this.intlMsg.msg('title')}
        <div className="pull-right">
          <Button
            bsStyle="aisz-danger"
            disabled={!network || !checked.length}
            className={styles.addBtn}
            onClick={() => this.setState({ showDelete: true })}
          >
            <i className="halflings halflings-trash" />&nbsp;
            {this.intlMsg.msg('batch.delete')}
          </Button>
          <Button
            bsStyle="aisz-primary"
            disabled={!network}
            className={styles.addBtn}
            onClick={() => this.props.pushState('/network/tdm/batch/pairs')}
          >
            <i className="fa fa-arrow-circle-right" />&nbsp;
            {this.intlMsg.msg('batch')}
          </Button>
          <Button
            bsStyle="aisz-success"
            disabled={!network}
            onClick={() => this.setState({ showCreate: true })}
            className={styles.addBtn}
          >
            <span className="glyphicons glyphicons-plus" aria-hidden="true" />&nbsp;
            {this.intlMsg.msg('add')}
          </Button>
        </div>
      </div>
    );
    return (
      <Panel bsStyle="aisz-white" header={header}>
        <div className={styles.searchIpt}>
          <SearchInput
            value={search}
            placeholder={this.intlMsg.msg('search.placeholder')}
            onChange={this.onChangeSearch}
          />
        </div>
        {this.renderTable()}
        <ShowIf if={status === 'success' && !list.length}>
          <div className={styles.noData}>{this.intlMsg.msg('nodata')}</div>
        </ShowIf>
        <ShowIf if={list.length > 0}>
          <div className={styles.pager}>
            <TablePagerTDM
              status={status}
              mark={mark}
              more={more}
              reset={reset}
              onPrev={this.handlePaging}
              onNext={this.handlePaging}
            />
          </div>
        </ShowIf>
        <CreateModal
          show={showCreate}
          deletePair={deletePair}
          onHide={() => this.setState({ showCreate: false })}
          onAdded={this.callback}
        />
        <DeleteModal
          show={showDelete}
          checkedPairs={checked}
          onDelSuccess={this.callback}
          onCancel={() => this.setState({ showDelete: false })}
        />
      </Panel>
    );
  }
}

Pairs.propTypes = propTypes;

const mapDispatchToprops = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToprops)(injectIntl(Pairs));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/Pairs/index.jsx